<template>
    <v-dialog
            v-model="isDialogOpen"
            width="500"
    >
        <template v-slot:activator="{ on }" v-if="internalActivator">
        <v-btn
                color="teal"
                dark
                text
                v-on="on"
                class="overline"
                height="20px"
        >
            ({{ $t('more').toLowerCase() }} {{ regionsCount }})
        </v-btn>
    </template>
        <v-card>
            <v-card-text>
                <div class="title py-3">
                    {{ $t('distributorRegions') }}
                </div>
                <v-divider class="mb-5"></v-divider>
                <v-btn
                        class="mr-3 mb-3"
                        outlined
                        depressed
                        disabled
                        color="orange"
                        v-for="(region, idx) in regions"
                        :key="idx"
                >
                    {{ region }}
                </v-btn>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="grey"
                        text
                        @click="$emit('close')"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "RegionsDialog",
        props: ['isOpen', 'regionsData', 'internalActivator'],
        data() {
            return {

            }
        },
        computed: {
            regions: {
                get() {
                    return this.regionsData;
                },

                set(value) {}
            },
            regionsCount() {
                return this.regionsData.length - 1;
            },
            isDialogOpen: {
                get() {
                    return this.isOpen;
                },
                set(value) {
                    if(!value) {
                        this.$emit('close');
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
